import api from '../../utils/axios';

export const referService = {
  getPublicProfile: async (agentParam) => {
    const response = await api.get(`/agent/public-profile?agent=${encodeURIComponent(agentParam)}`);
    return response.data;
  }
};

export default referService;
